<template>

    <div class="input-group | vn-input-checkbox checkbox-group" :class="cssInputClass">
        <input
            :name="key"
            :id="instanceId"
            type="checkbox"
            v-model="value"
            @blur="clearError"
        />
        <label class="checkbox-label" :for="instanceId"><span v-html="field.title"></span></label>
        <span class="error-message" v-if="gotError"> {{ errorMessage }} </span>
    </div>

</template>

<script>

export default {
    name : "InputCheckbox",
}

</script>

<script setup>

import { onMounted, ref } from 'vue';

let instanceId = ref( null );

import useFormInput from "../../composables/useFormInput";
import { uniqueId } from 'lodash-es';

let props = defineProps( [ "field" ] );

let { gotError, clearError, cssInputClass, errorMessage, value, key, exposed } = useFormInput( props );

defineExpose( exposed );


onMounted( () =>
{
    if ( instanceId.value === null )
    {
        instanceId.value = uniqueId( props.field.key + '_' );
    }
} )
</script>
